// material-ui
import useMediaQuery from '@mui/material/useMediaQuery';

// project imports
import DrawerHeaderStyled from './DrawerHeaderStyled';
import Logo from 'components/logo';

import useConfig from 'hooks/useConfig';
import { MenuOrientation } from 'config';

interface Props {
  open: boolean;
}

// ==============================|| DRAWER HEADER ||============================== //

export default function DrawerHeader({ open }: Props) {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  const { menuOrientation } = useConfig();
  const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL && !downLG;

  return (
    <DrawerHeaderStyled
      open={open}
      sx={{
        minHeight: isHorizontal ? 'unset' : '85px',
        width: isHorizontal ? { xs: '100%', lg: '424px' } : 'initial',
        paddingTop: isHorizontal ? { xs: '10px', lg: '0' } : '12px',
        paddingBottom: isHorizontal ? { xs: '18px', lg: '0' } : '12px',
        paddingLeft: isHorizontal ? { xs: '24px', lg: '0' } : 0,
        justifyContent: isHorizontal ? 'center' : open ? 'center' : 'center'
      }}
    >
      <Logo isIcon={!open} sx={{ width: open ? '100%' : 45, height: open ? 70 : 45 }} />
    </DrawerHeaderStyled>
  );
}
